export default "__VITE_ASSET__CDKAx86V__"